import React from "react";

export class FoodBox extends React.Component {
  render() {
    let FoodList = this.props.Foods.map(function(Food, index) {
      return (
        <div key={index} className="col-xl-4 col-centered">
          <div className="card foodCard">
            <div className="card-block">
              <h4 className="card-title">{Food.Name}</h4>
              <p dangerouslySetInnerHTML={{ __html: Food.Description }} />
            </div>
            <div className="foodPrice btn  btn-primary">{Food.Price}kr</div>
          </div>
        </div>
      );
    });

    return <div className="row Food">{FoodList}</div>;
  }
}

export default FoodBox;



// WEBPACK FOOTER //
// ./src/Components/Food/FoodBox.js